(function () {
  var configEl = document.getElementById('TimeslotConfig');
  if (!configEl) return;
  var config = JSON.parse(configEl.textContent);
  if (!config.enabled) return;

  var interval = parseInt(config.interval, 10) || 15;
  var cutoffParsed = parseInt(config.cutoff, 10);
  var cutoff = isNaN(cutoffParsed) ? 30 : cutoffParsed;
  var daysAhead = parseInt(config.daysAhead, 10) || 3;

  var modal = document.getElementById('TimeslotModal');
  var dateSelect = document.getElementById('TimeslotDate');
  var timeSelect = document.getElementById('TimeslotTime');
  var submitBtn = document.getElementById('TimeslotSubmit');
  var closedMsg = document.getElementById('TimeslotClosedMsg');

  // Le config est global (toutes les pages) mais le markup du modal peut être
  // absent (page atypique / futur refactor) : on sort proprement plutôt que de
  // lancer une TypeError sur addEventListener plus bas.
  if (!modal || !dateSelect || !timeSelect || !submitBtn || !closedMsg) return;

  var state = { triggerEl: null };

  var DAY_NAMES = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
  var MONTH_NAMES = ['jan.', 'f\u00e9v.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'ao\u00fbt', 'sept.', 'oct.', 'nov.', 'd\u00e9c.'];

  function clearSelect(selectEl) {
    while (selectEl.firstChild) selectEl.removeChild(selectEl.firstChild);
  }

  function addOption(selectEl, value, text) {
    var opt = document.createElement('option');
    opt.value = value;
    opt.textContent = text;
    selectEl.appendChild(opt);
  }

  function parseRanges(str) {
    if (!str || !str.trim()) return [];
    return str.split(',').map(function (r) {
      var parts = r.trim().split('-');
      if (parts.length !== 2) return null;
      var start = parts[0].trim().split(':');
      var end = parts[1].trim().split(':');
      if (start.length !== 2 || end.length !== 2) return null;
      return {
        startH: parseInt(start[0], 10),
        startM: parseInt(start[1], 10),
        endH: parseInt(end[0], 10),
        endM: parseInt(end[1], 10)
      };
    }).filter(Boolean);
  }

  // Heure murale suisse : les horaires du resto sont en Europe/Zurich,
  // pas dans le fuseau du navigateur du client.
  function zurichNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' }));
  }

  function generateSlots(ranges, date) {
    var now = zurichNow();
    var cutoffTime = new Date(now.getTime() + cutoff * 60000);
    var slots = [];

    ranges.forEach(function (range) {
      var h = range.startH;
      var m = range.startM;
      var endMin = range.endH * 60 + range.endM;

      while (h * 60 + m + interval <= endMin) {
        // Filtre cutoff inconditionnel : couvre aussi le modal resté ouvert
        // à cheval sur minuit (une date devenue passée ne propose plus rien).
        var slotDate = new Date(date);
        slotDate.setHours(h, m, 0, 0);
        if (slotDate < cutoffTime) {
          m += interval;
          h += Math.floor(m / 60);
          m = m % 60;
          continue;
        }

        var slotEnd = h * 60 + m + interval;
        var startLabel = pad(h) + ':' + pad(m);
        var endH = Math.floor(slotEnd / 60);
        var endM = slotEnd % 60;
        var endLabel = pad(endH) + ':' + pad(endM);

        slots.push({ value: startLabel + ' - ' + endLabel, label: startLabel + ' \u2013 ' + endLabel });

        m += interval;
        h += Math.floor(m / 60);
        m = m % 60;
      }
    });

    return slots;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function formatDate(date) {
    var today = zurichNow();
    var tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (date.toDateString() === today.toDateString()) return "Aujourd'hui";
    if (date.toDateString() === tomorrow.toDateString()) return 'Demain';
    return DAY_NAMES[date.getDay()] + ' ' + date.getDate() + ' ' + MONTH_NAMES[date.getMonth()];
  }

  function buildDates() {
    clearSelect(dateSelect);
    addOption(dateSelect, '', '\u2014 Choisir une date \u2014');
    var hasAny = false;

    for (var i = 0; i < daysAhead; i++) {
      var d = zurichNow();
      d.setDate(d.getDate() + i);
      d.setHours(0, 0, 0, 0);

      var dayOfWeek = d.getDay();
      var hoursStr = config.hours[String(dayOfWeek)];
      var ranges = parseRanges(hoursStr);

      if (ranges.length === 0) continue;

      var slots = generateSlots(ranges, d);
      if (slots.length === 0) continue;

      hasAny = true;
      var dateVal = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
      addOption(dateSelect, dateVal, formatDate(d));
    }

    dateSelect.disabled = !hasAny;
    closedMsg.style.display = hasAny ? 'none' : 'block';
    if (!hasAny) {
      closedMsg.textContent = 'Aucun cr\u00e9neau disponible pour les ' + daysAhead + ' prochains jours';
    }
  }

  function buildTimeSlots() {
    clearSelect(timeSelect);
    addOption(timeSelect, '', '\u2014 Choisir un cr\u00e9neau \u2014');
    var dateVal = dateSelect.value;
    if (!dateVal) {
      timeSelect.disabled = true;
      validate();
      return;
    }

    var parts = dateVal.split('-');
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    var dayOfWeek = d.getDay();
    var ranges = parseRanges(config.hours[String(dayOfWeek)]);
    var slots = generateSlots(ranges, d);

    slots.forEach(function (slot) {
      addOption(timeSelect, slot.value, slot.label);
    });

    timeSelect.disabled = slots.length === 0;
    validate();
  }

  function validate() {
    submitBtn.disabled = !(dateSelect.value && timeSelect.value);
  }

  function open(triggerEl) {
    state.triggerEl = triggerEl;

    closedMsg.style.display = 'none';
    submitBtn.disabled = true;

    clearSelect(timeSelect);
    addOption(timeSelect, '', 'Choisir une date d\'abord');
    timeSelect.disabled = true;

    buildDates();

    modal.classList.add('timeslot-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    modal.classList.remove('timeslot-modal--open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (state.triggerEl) {
      var originalText = state.triggerEl.getAttribute('data-original-text') || 'Commander';
      state.triggerEl.textContent = originalText;
      state.triggerEl.disabled = false;
      state.triggerEl.style.pointerEvents = '';
    }
    window._checkoutInProgress = false;
  }

  function onDateChange() {
    buildTimeSlots();
  }

  function submit() {
    if (submitBtn.disabled) return;

    var dateVal = dateSelect.value;
    var dateLabel = dateSelect.options[dateSelect.selectedIndex].text;
    var timeVal = timeSelect.value;

    submitBtn.textContent = 'Enregistrement...';
    submitBtn.disabled = true;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Date souhait\u00e9e': dateLabel + ' (' + dateVal + ')',
          'Cr\u00e9neau horaire': timeVal
        }
      })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    })
    .then(function () {
      modal.classList.remove('timeslot-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      window._checkoutInProgress = false;
      window._timeslotConfirmed = true;
      window.prepareCheckout(state.triggerEl);
    })
    .catch(function () {
      submitBtn.textContent = 'Continuer le paiement';
      submitBtn.disabled = false;
      if (window.showToast) {
        window.showToast('Erreur lors de l\'enregistrement du cr\u00e9neau. R\u00e9essayez.', 'error');
      }
    });
  }

  timeSelect.addEventListener('change', validate);

  window._timeslotModal = { open: open, close: close, onDateChange: onDateChange, submit: submit };
  window.showTimeslotModal = open;
})();
